const mEditionProductDiscountCodes = {
  mEditionProductDiscountCodes: {
    buttonSecondary: {
      createText: 'Crear Código'
    },

    dateText: {
      noEnd: 'Sin Fin',
      noStart: 'Sin Inicio'
    },

    quote: 'Aquí puedes crear cupones o códigos de descuento para la venta de tu producto. El descuento se aplicará sobre el precio final del producto al momento de ser ingresado el nombre del código en el formulario de venta.',

    table: {
      thAmount: 'Porcentaje',
      thCode: 'Código',
      thDelete: 'Eliminar',
      thEdit: 'Editar',
      thEnd: 'Fecha Fin',
      thStart: 'Fecha Inicio',
      thType: 'Tipo'
    },

    tooltip: {
      delete: 'Eliminar Código',
      edit: 'Editar Código'
    }
  }
}

export default mEditionProductDiscountCodes
